export const MODULE_NAME = 'auth'
export const USER_STORE_ID = `${MODULE_NAME}/user`

export const RURALITY_API_REGISTRATION = 'auth/registration'
export const NUXT_API_AUTH_REGISTRATION = `${MODULE_NAME}/registration`

export const RURALITY_API_IS_LOGGED_AND_ALLOWED =
  'user/:id/is-logged-and-allowed'
export const NUXT_API_AUTH_ADMIN = `${MODULE_NAME}/auth-admin`

export const signUpOrigin = {
  OWNER_SIGNUP_PAGE: 'owner-signup-page',
  PAGINA_REGISTRO_MAIL: 'pagina-registro(mail)',
  PAGINA_REGISTRO_GOOGLE: 'pagina-registro(google)',
  PAGINA_REGISTRO_OPTIN: 'pagina-registro-optin',
}
